<template>
<div>
		<div class="ic_layout">
		<div class="ic_wrong ic_wrong2">
			<p>您该网页未授权...</p>
			<router-link :to="{path:'/index'}" class="ic_wrong_back">返回首页</router-link>
		</div>
		</div>
	<div class="ic_footer" style="background: rgb(238,238,238)">
		<p>全国网络交易监管服务平台 &nbsp;&nbsp;版权所有</p>
	</div>
 </div>
</template>
<script>
export default {
  created() {
    setTimeout(() => {
      this.$router.push({
        path: '/index'
      })
    }, 3000)
  }
}
</script>

<style>
@import '../assets/css/black_style.css';
@import '../assets/css/aicUser.css';
@import '../assets/css/bright.css';
</style>



// WEBPACK FOOTER //
// src/components/t404.vue